<!-- =========================
     PRE LOADER       
============================== -->
<!-- <div class="preloader">
    <div class="status">&nbsp;</div>
</div> -->

<!-- =========================
           HEADER   
      ============================== -->
<header id="home">
    <!-- COLOR OVER IMAGE -->
    <div class="color-overlay">
        <div class="navbar-header">
            <nav class="navbar navbar-expand-lg navbar-light bg-light">
                <a class="navbar-brand text-left" href="/"><img src="{{signupLogo}}" /></a>
            </nav>
        </div>
        <!-- HEADING, FEATURES AND REGISTRATION FORM CONTAINER -->
        <div class="container">

            <div class="row">

                <!-- LEFT - HEADING AND TEXTS -->
                <div class="col-md-7 col-sm-7 intro-section">

                    <h1 class="intro-section-header text-left">
                        Helping You
                        <strong>Create</strong> the
                        <strong>Change</strong> Your Clients Want
                    </h1>

                    <ul class="feature-list-1">
                        <!-- FEATURE ROW -->
                        <li>
                            <div class="icon-container pull-left">
                                <span class="fa fa-check"></span>
                            </div>
                            <p class="text-left">
                                <strong>Unlimited access to valid and reliable digital assessments for diagnosis and treatment planning.
                                </strong>
                            </p>
                        </li>

                        <!-- FEATURE ROW -->
                        <li>
                            <div class="icon-container pull-left">
                                <span class="fa fa-check"></span>
                            </div>
                            <p class="text-left">
                                <strong>Unlimited access to a growing library of homework exercises and articles to provide ongoing support to your clients.</strong>
                            </p>
                        </li>

                        <!-- FEATURE ROW -->
                        <li>
                            <div class="icon-container pull-left">
                                <span class="fa fa-check"></span>
                            </div>
                            <p class="text-left">
                                <strong>No commitment required -- try the service absolutely free with no credit card required.</strong>
                            </p>
                        </li>

                    </ul>

                </div>

                <!-- RIGHT - REGISTRATION FORM -->

                <div class="col-md-5 col-sm-5">

                    <div class="vertical-registration-form">
                        <div class="colored-line">
                        </div>
                        <h3>{{getFreeTrialPeriod()}} Day Free Trial<br /><small>No Credit Card Required</small></h3>
                        <form class="registration-form" id="register" role="form">
                            <!-- <amplify-authenticator [usernameAttributes]="email"></amplify-authenticator> -->
                            <div *ngIf="authState == 'signUp'">
                                <input class="form-control input-box" id="companyName" type="text" name="companyName" placeholder="Company Name" [(ngModel)]="Company.name"
                                />
                                <input class="form-control input-box" id="email" type="text" name="email" placeholder="Email" [(ngModel)]="Company.email">
                                <input class="form-control input-box" id="password" type="password" name="password" placeholder="Password" [(ngModel)]="password">
                                <!-- <input class="form-control input-box" id="confirmPassword" type="password" name="confirmPassword" placeholder="Confirm Password"
                                    [(ngModel)]="confirmPassword"> -->
                                <button *ngIf="!processingSignup" class="btn btn-primary" (click)="signup()" type="submit" id="submit" name="submit">Get Started</button>
                                <button *ngIf="processingSignup" class="btn btn-primary" type="submit" id="submit" disabled="disabled" name="submit">Processing</button>
                                <p class="small text-light">By clicking Get Started, you agree to the <a target="_blank" [routerLink]="['/baa']">Business Associate Agreement</a>, <a target="_blank" [routerLink]="['/terms-and-conditions']">Terms of Service</a>, and <a target="_blank" [routerLink]="['/privacy']">Privacy Policy.</a></p>
                            </div>
                            <div *ngIf="authState != 'signUp'">
                                <p class='text-light'>Please enter the code you received in your email</p>
                                <input class="form-control input-box" id="confirmationCode" type="text" name="confirmationCode" placeholder="Confirmation Code" [(ngModel)]="confirmationCode"
                                />
                                <button class="btn btn-primary" [disabled]="processingSignup" (click)="confirmSignup()" type="submit" id="submit" name="submit">Confirm Email</button>
                                <app-spin-icon *ngIf="processingSignup"></app-spin-icon>
                                <p>Didn't receive a code?  <a href="#" (click)="resendConfirmationCode($event)">Resend code</a></p>
                            </div>
                            <p class='text-white'><small><a class='text-primary' [routerLink]="['/', 'loginAdmin']">Login</a> if you already have an account</small></p>
                            
                        </form>
                    </div>
                </div>
                <!-- /END - REGISTRATION FORM -->
            </div>

        </div>
        <!-- /END HEADING, FEATURES AND REGISTRATION FORM CONTAINER -->

    </div>

</header>

<!-- =========================
     SECTION 1   
============================== -->
<section class="section1" id="section1">

    <div class="container">
        <div class="row">

            <div class="col-md-6">

                <!-- SCREENSHOT -->
                <div class="side-screenshot pull-left">
                    <img src="/assets/images/screenshot-1.png" alt="Feature" class="img-fluid">
                </div>

            </div>

            <div class="col-md-6">

                <!-- DETAILS WITH LIST -->
                <div class="brief text-left">

                    <!-- HEADING -->
                    <h2>Assessments Made Easy</h2>
                    <div class="colored-line pull-left">
                    </div>

                    <!-- TEXT -->
                    <p>
                        What would it be like to ask your client to take an assessment and then be able to quickly review their results without spending
                        time adding the scores up and then reviewing what that means for your client. The graphs enable you
                        to identify what your client needs and focus on giving them the treatment they need. Simple and easy.
                    </p>

                    <!-- FEATURE LIST -->
                    <ul class="feature-list-2">

                        <!-- FEATURE -->
                        <li>
                            <!-- ICON -->
                            <div class="icon-container pull-left">
                                <span class="fa fa-cog"></span>
                            </div>
                            <!-- DETAILS -->
                            <div class="details pull-left">
                                <h6>Easy to Customize</h6>
                                <p>
                                        Whether your client has depression, anxiety, trauma, or addiction you can send them the assessment they need with a simple click.
                                </p>
                            </div>
                        </li>

                        <!-- FEATURE -->
                        <li>
                            <!-- ICON -->
                            <div class="icon-container pull-left">
                                <span class="fa fa-list"></span>
                            </div>
                            <!-- DETAILS -->
                            <div class="details pull-left">
                                <h6>Battery of Assessments</h6>
                                <p>
                                    We've put together comprehensive batteries for key assessment areas to save you time and effort. 
                                    Assign the battery and your clients get all the assessments with just a single click.
                                </p>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- /END DETAILS WITH LIST -->

        </div>
        <!-- END ROW -->

    </div>
    <!-- END CONTAINER -->

</section>
<!-- =========================
     SECTION 2   
============================== -->
<section class="section2 bgcolor-2" id="section2">

    <div class="container">

        <!-- SECTION HEADING -->

        <h2>Key Features</h2>

        <div class="colored-line">
        </div>

        <!-- <div class="sub-heading">
                Term sheet convertible note colluding bootstrapping.
            </div> -->

        <div class="features">

            <!-- FEATURES ROW 1 -->
            <div class="row">

                <!-- SINGLE FEATURE BOX -->
                <div class="col-md-4">
                    <div class="feature">
                        <div class="icon">
                            <span class="fa fa-bar-chart"></span>
                        </div>
                        <h4>Top Level Summarys</h4>
                        <p>
                            We do the heavy lifting by providing summary graphs and reports of your clients assessment results so you can focus on what you do the best—help
                            your clients heal. 
                        </p>
                    </div>
                </div>

                <!-- SINGLE FEATURE BOX -->
                <div class="col-md-4">
                    <div class="feature">
                        <div class="icon">
                            <span class="fa fa-map"></span>
                        </div>
                        <h4>Comprehensive reports</h4>
                        <p>
                             You can review a top level summary or dive in for an in-depth breakdown of your clients' answers and what they mean.
                        </p>
                    </div>
                </div>

                <!-- SINGLE FEATURE BOX -->
                <div class="col-md-4">
                    <div class="feature">
                        <div class="icon">
                            <span class="fa fa-gift"></span>
                        </div>
                        <h4>Mobile Friendly</h4>
                        <p>
                            All of our assessments have been built and tested to work on android and iOS devices as well as desktop platforms.
                        </p>
                    </div>
                </div>
            </div>

            <!-- FEATURES ROW 2 -->
            <div class="row">

                <!-- SINGLE FEATURE BOX -->
                <div class="col-md-4">
                    <div class="feature">
                        <div class="icon">
                            <span class="fa fa-line-chart"></span>
                        </div>
                        <h4>Track client progress</h4>
                        <p>
                            Measure progress over time from the first to your last session. Anytime you give a follow up assessment you will see your
                            clients improvement.
                        </p>
                    </div>
                </div>


                <!-- SINGLE FEATURE BOX -->
                <div class="col-md-4">
                    <div class="feature">
                        <div class="icon">
                            <span class="fa fa-clipboard"></span>
                        </div>
                        <h4>Assign Homework</h4>
                        <p>
                            Provide additional support by giving homework to your clients with our library of exercises and articles. 
                        </p>
                    </div>
                </div>

                 <!-- SINGLE FEATURE BOX -->
                 <div class="col-md-4">
                    <div class="feature">
                        <div class="icon">
                            <span class="fa fa-lock"></span>
                        </div>
                        <h4>HIPAA Compliant</h4>
                        <p>
                            We offer a <a [routerLink]='["/baa"]'>BAA</a> for your organization.  We keep your client's PHI safe by both encryption (in transit and at rest) as well as following industry best practices.  
                        </p>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <!-- /END CONTAINER -->
</section>
<dac-pricing-table class="section2 bgcolor-2 d-block primary-gradient" (selected)="handlePlan($event)"></dac-pricing-table>

<!-- =========================
     SECTION 3   
============================== -->
<section class="section3" id="section3">

    <div class="container">
        <div class="row">

            <div class="col-md-8">

                <!-- DETAILS WITH LIST -->
                <div class="brief text-left">

                    <!-- HEADING -->
                    <h2>Why Assessments Matter!</h2>
                    <div class="colored-line pull-left">
                    </div>
                    <blockquote class="blockquote mt-4 p-0">
                        <p class="mb-0 pt-0">“Why didn’t my other therapists ask me these questions?”</p>
                    </blockquote>
                    <p>These were the first words my new client said to me when she sat down. She continued, </p>
                    <blockquote class="blockquote p-0">
                        <p class="mb-0 pt-0">“I have been to four other therapists and spent more than $10,000 since I discovered my partner’s
                            affair and none of my other therapists have addressed the issues this assessment did. Why don’t
                            all therapists ask these questions?”
                        </p>
                    </blockquote>
                    <p class="mt-0">
                        <strong>I was completely caught off guard.</strong>
                    </p>
                    <p class="mt-0">
                        I later learned that my client had spent years trying to figure out what was wrong with her. She had been to therapy, but
                        none of her therapists had addressed her core trauma’s. Had those therapists had access to the same
                        assessments I did, they could have helped her earlier because they would have discovered the depth
                        of what she had been going through. She became one of our best referral sources over the next few
                        months as she sent members of her 12-step support group to our agency.
                    </p>
                </div>
            </div>
            <div class="col-md-4">
                <div class="row justify-content-center">
                    <div class="col text-center">
                        <img src="/assets/images/therapist-kevin-skinner.jpg" class="img-fluid" />
                        <p>Dr. Kevin Skinner LMFT</p>
                    </div>
                </div>
            </div>
        </div>

    </div>
</section>

<!-- =========================
     SECTION 4   
============================== -->
<section class="section4 bgcolor-2" id="section4">

    <div class="container">



        <h2>How to get started</h2>

        <div class="colored-line">
        </div>

        <div class="sub-heading">Signup now and get started in six easy steps.</div>

        <div class="features">


            <div class="row">


                <div class="col-md-4">
                    <div class="feature">
                        <div class="icon">
                            <h1>
                                <span class="badge badge-pill badge-primary">1</span>
                            </h1>
                        </div>
                        <h4>Create your free {{getFreeTrialPeriod()}} Day Trial Account</h4>
                        <p>
                            Get unlimited access for free during the trial period, test it yourself or with your clients, and get a feel for our system without paying anything.
                        </p>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="feature">
                        <div class="icon">
                            <h1>
                                <span class="badge badge-pill badge-primary">2</span>
                            </h1>
                        </div>
                        <h4>Create a client</h4>
                        <p>
                            Add a new client, providing their contact information and email address.  This information is encrypted and secure.  The system
                            will generate a unique token for them to use.
                        </p>
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="feature">
                        <div class="icon">
                            <h1>
                                <span class="badge badge-pill badge-primary">3</span>
                            </h1>
                        </div>
                        <h4>Create an Assignment</h4>
                        <p>
                            Pick from one of our curated batteries or pick from assessments for areas such as Adult ADHD, Anxiety, Depression, PTSD, Relationship Satisfaction , Betrayal Trauma,
                            Adverse Childhood Experiences, Hypersexual Behavior, and much more…
                        </p>
                    </div>
                </div>
            </div>

            <div class="row">


                <div class="col-md-4">
                    <div class="feature">
                        <div class="icon">
                            <h1>
                                <span class="badge badge-pill badge-primary">4</span>
                            </h1>
                        </div>
                        <h4>Send the invitation email to your client</h4>
                        <p>
                            At a click of a button invite your client to get started or copy the invitation to your own email client and send it from there.
                        </p>
                    </div>
                </div>


                <div class="col-md-4">
                    <div class="feature">
                        <div class="icon">
                            <h1>
                                <span class="badge badge-pill badge-primary">5</span>
                            </h1>
                        </div>
                        <h4>Review Results</h4>
                        <p>
                            You'll receive an email notification when your client's finish their results.  From there you can review your clients test results and discuss the results with them.
                        </p>
                    </div>
                </div>


                <div class="col-md-4">
                    <div class="feature">
                        <div class="icon">
                            <h1>
                                <span class="badge badge-pill badge-primary">6</span>
                            </h1>
                        </div>
                        <h4>Upload Client Results</h4>
                        <p>
                            If you choose, you can generate a PDF of your client's results to store in your EHR or just copy a shareable link that will bring you back to your client.
                        </p>
                    </div>
                </div>

            </div>

        </div>

    </div>
</section>

<!-- =========================
     SECTION 7  
============================== -->
<section class="section7" id="section7">
    <div class="container">

        <!-- SECTION HEADING -->
        <h2>Our Valued Partnerships</h2>
        <div class="colored-line">
        </div>

        <!-- CLIENTS -->
        <div class="row clients justify-content-center">
            <div class="col-5 col-md-3" *ngIf="showPartner('apsats')">
                <a href="https://www.apsats.org/">
                    <img class="img-fluid" src="/assets/images/logo-apsats.png" alt="APSATS Logo">
                </a>
            </div>
            <div class="col-5 col-md-3" *ngIf="showPartner('apsats')">
                <a href="https://addorecovery.com/">
                    <img class="img-fluid" src="/assets/images/logo-addo.png" alt="Addo Recovery Logo">
                </a>
            </div>
            <div class="col-5 col-md-3" *ngIf="showPartner('discoverandchange')">
                <a href="https://www.discoverandchange.com/">
                    <img class="img-fluid" src="/assets/images/logo-discoverandchange.dark.png" alt="Discover and Change Logo">
                </a>
            </div>

        </div>
    </div>
    <!-- /END CONTAINER -->

</section>

<!-- =========================
     SECTION 8 - CTA  
============================== -->
<section class="cta-section" id="section8">
    <div class="color-overlay">
        <div class="container">
            <h4>Helping You Create the Change Your Clients Want</h4>
            <div id="cta-4">
                <a (click)="handleCTA()" class="btn btn-primary"> Get Started</a>
            </div>
        </div>
        <!-- /END CONTAINER -->
    </div>
    <!-- /END COLOR OVERLAY -->

</section>


// WEBPACK FOOTER //
// ./src/app/companies/signup/signup.component.html